import { useEffect } from 'react';
import { trackPageView } from '../utils/pixelTracker';

const PixelTracker = () => {
  useEffect(() => {
    trackPageView();
  }, []);

  return null;
};

export default PixelTracker;
